module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/modals/copy-invoice-to-quickBooks/copy-invoice-to-quickBooks.modal.scss
// module id = ./web/modern/components/invoices/modals/copy-invoice-to-quickBooks/copy-invoice-to-quickBooks.modal.scss
// module chunks = 0